type OwnProps = {
  id?: string;
  className?: string;
  style?: $TSFixMe;
  children?: React.ReactNode;
};

const defaultProps: Partial<OwnProps> = {
  id: undefined,
  className: undefined,
  style: undefined,
  children: undefined,
};

type Props = OwnProps & typeof defaultProps;

function Row({ id, className, style, children }: Props) {
  return (
    <div
      id={id}
      className={["row", className].filter((c) => c).join(" ")}
      style={style}
    >
      {children}
    </div>
  );
}

Row.defaultProps = defaultProps;

export default Row;
